import { RoutesEnum } from '@src/app/enums';
import { TMediaType } from '@src/app/shared/types/common';

export const perItem = 20;

export const mediaLimits: Record<TMediaType, number> = {
  [RoutesEnum.NEWS]: 16,
  [RoutesEnum.BLOG]: 21,
} as const;
